import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from '../../components/modal/modal';
import PropTypes from 'prop-types';
import { SimpleDataTable } from '../../components/data-table/simple-data-table';
import PubSub from '../../services/pubsub-service';
import * as PubSubActionType from '../../services/constants';
import * as ProjectActionType from '../../Projects/constants';
import * as LotActionType from '../constants';
import * as ModelActionType from 'Model/constants';
import UploadButton from '../../components/upload-button/index';
import '../lot.scss';
import Translate from 'components/translate';

class ImportExcelLot extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    dispatch: PropTypes.func,
    ImportErrorResult: PropTypes.array,
    ErrorMsg: PropTypes.array,
    ImportSuccessResult: PropTypes.array,
    IsSuccessImport: PropTypes.bool,
    ManageLots: PropTypes.object,
    ManagePhases: PropTypes.object,
    ManageModels: PropTypes.object,
    projectId: PropTypes.string
  };
  constructor(props) {
    super(props);

    this.projectId = this.props.match.params.projectId
      ? this.props.match.params.projectId.replace('&', '')
      : this.props.projectId;

    this.isNew = this.props.match.params.isNew === 'true';

    this.state = {
      projectName: '',
      isValid: true,
      error: '',
      errorList: [],
      isLotSuccess: false,
      lotAdded: null,
      lotEdited: null,
      isProcessing: false,
      numberError: 0,
      columns: [
        {
          title: 'Row',
          name: 'row'
        },
        {
          title: 'Lot#',
          name: 'lot'
        },
        {
          title: 'Error',
          name: 'error'
        }
      ]
    };

    var me = this;

    PubSub.subscribe(
      PubSubActionType.PUBLISH_PROJECT_INFORMATION,
      (msg, data) => {
        me.setState({ projectName: data.project.name });
      }
    );
  }

  componentDidMount() {
    // this.props.dispatch({
    //   type: ProjectActionType.GET_PROJECT_BY_ID_ASYNC,
    //   params: this.projectId
    // });
  }

  componentWillReceiveProps(nextProps) {
    let state = {
      isValid: true,
      error: '',
      errorList: [],
      isProcessing: false,
      numberError: 0
    };

    if (
      nextProps.ImportSuccessResult.length > 0 &&
      nextProps.IsSuccessImport &&
      nextProps.IsSuccessImport !== this.props.IsSuccessImport
    ) {
      state['lotAdded'] = nextProps.ImportSuccessResult[0].countAdded;
      state['lotEdited'] = nextProps.ImportSuccessResult[0].countEdited;
      state['isLotSuccess'] = true;
      state['numberError'] = 0;
      this.props.dispatch({
        type: ProjectActionType.SEARCH_PHASE_ASYNC,
        params: this.objToParams(this.props.ManagePhases.params)
      });
      this.props.dispatch({
        type: ModelActionType.SEARCH_MODEL_ASYNC,
        params: this.objToParams(this.props.ManageModels.params)
      });
      this.props.dispatch({
        type: LotActionType.GET_LOT_TAB_ASYNC,
        params: this.objToParams({
          ...this.props.ManageLots.params,
          sort: { ...this.props.ManageLots.params.sort, field: 'phaseName' }
        })
      });
    } else if (nextProps.ImportErrorResult.items) {
      state['errorList'] = nextProps.ImportErrorResult.items;
      state['numberError'] = nextProps.ImportErrorResult.items.length;
      state['isLotSuccess'] = false;
    }

    if (nextProps.ErrorMsg.length > 0) {
      state['isValid'] = false;
      state['error'] = nextProps.ErrorMsg[0];
      state['numberError'] = 0;
    }

    this.setState(state);
  }

  componentWillUnmount() {
    // this.props.dispatch({
    //   type: LotActionType.RESET_LOT,
    //   params: null
    // });
    // this.props.dispatch({
    //   type: ProjectActionType.RESET_PROJECT,
    //   params: null
    // });
  }

  objToParams = obj => {
    return {
      searchKey: '',
      projectId: this.projectId,
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      skip: obj.skip - 1,
      take: obj.take
    };
  };

  onHandleFileUpload(e) {
    //https://gist.github.com/AshikNesin/e44b1950f6a24cfcd85330ffc1713513
    let file = e.target.files[0];

    if (file.name.indexOf('.xlsx') === -1) {
      this.setState({ isValid: false, error: 'Only .xlsx supported' });
      return;
    }

    let data = new FormData();

    data.append('file', file);

    data.append('projectId', this.projectId);

    this.props.dispatch({
      type: LotActionType.IMPORT_LOT_ASYNC,
      params: {
        data,
        projectId: this.projectId
      }
    });

    this.setState({ isValid: true, error: '', isProcessing: true });

    e.target.value = null;
  }

  checkEditedNumber() {
    if (this.state.lotEdited > 0) {
      return (
        <span>
          , {this.state.lotEdited} <Translate translateKey='lot' plurals />{' '}
          updated
        </span>
      );
    } else {
      return null;
    }
  }

  showListError() {
    $('#frmModal').modal({
      show: 'false',
      backdrop: 'static',
      keyboard: false
    });
  }

  closeModal() {
    $('#frmModal').modal('hide');
  }

  onTableBinding(configTable) {
    this.binding({
      ...this.objToParams(this.props.ManageLots.params),
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip,
      take: configTable.page.take
    });
  }

  renderTableLot() {
    if (this.state.numberError > 0) {
      return (
        <SimpleDataTable
          columns={this.state.columns}
          items={this.state.errorList}
          configTable={this.props.ManageLots.params}
          onTableBinding={this.onTableBinding.bind(this)}
        />
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <div style={{ marginTop: -20 }}>
        <div style={{ float: 'none', margin: '0 auto' }}>
          <div className='tab-content'>
            <div className='tab-pane fade in active'>
              <p style={{ fontSize: 14, margin: '0 0 5px 0' }}>
                You are highly recommended to download our excel template so
                that you won't waste your time uploading a file with incorrect
                format.
              </p>
              <div style={{ marginBottom: 10 }}>
                <a
                  href={`${
                    window.profile.currentSiteUri
                  }/api/static-files/download-lot-tmpl`}
                  style={{ textDecoration: 'underline' }}
                >
                  Download excel template
                </a>
              </div>

              <UploadButton
                name='upload-excel'
                accept='.xlsx'
                label='Import...'
                tooltip='Supported file types: .xlsx'
                onChange={this.onHandleFileUpload.bind(this)}
                ref={el => {
                  this.uploadFile = el;
                }}
              />
              <br />
              <p
                className='errorNotice'
                style={{ display: this.state.isValid ? 'none' : 'block' }}
              >
                <span>
                  <span onClick={this.showListError.bind(this)}>
                    <i className='glyphicon glyphicon-info-sign' />{' '}
                  </span>
                  {this.state.error}{' '}
                </span>
              </p>

              <p
                className='lotNotice'
                style={{ display: this.state.isLotSuccess ? 'block' : 'none' }}
              >
                <i className='glyphicon glyphicon-ok-sign' />{' '}
                {this.state.lotAdded} lots added{this.checkEditedNumber()}
              </p>
              <p
                className='errorNotice'
                style={{
                  display: this.state.numberError > 0 ? 'block' : 'none'
                }}
              >
                <span onClick={this.showListError.bind(this)}>
                  <i className='glyphicon glyphicon-info-sign' />{' '}
                  {this.state.numberError} invalid lots
                </span>{' '}
                detected. Import process is canceled.
              </p>
              <Modal modalId='frmModal'>
                <div
                  className='modal-content'
                  style={{ paddingLeft: 15, paddingRight: 15 }}
                >
                  <div className='modal-header'>
                    <h4 className='modal-title cls-text-align-center'>
                      Invalid data
                    </h4>
                    <button
                      className='close'
                      onClick={this.closeModal.bind(this)}
                    >
                      <span aria-hidden='true'>×</span>
                    </button>
                  </div>
                  {this.renderTableLot()}
                  <p>Please correct and re-import</p>
                  <div className='text-center' style={{ marginBottom: 15 }}>
                    <button
                      className='btn btn-primary btnConfirm'
                      onClick={this.closeModal.bind(this)}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.LotStore,
    ManagePhases: state.PhaseStore.ManagePhases,
    ManageModels: state.ModelStore.ManageModels
  };
};

export default connect(mapStateToProps)(ImportExcelLot);



// WEBPACK FOOTER //
// ./src/Lots/Containers/import-excel-lot.js